export const HEADER_HEIGHT = 54;

export const desktopNavigationData = (t: any) => [
  {
    id: "overview",
    displayName: t("propertypage.components.propertyheader.overview"),
  },
  {
    id: "offers",
    displayName: t("propertypage.components.propertyheader.offers"),
  },
  {
    id: "description",
    displayName: t("propertypage.components.propertyheader.description"),
  },
  {
    id: "video_tour",
    displayName: t("propertypage.components.propertyheader.videotour"),
  },
  {
    id: "room_type",
    displayName: t("propertypage.components.propertyheader.roomtypes"),
    triggerInViewEvent: true,
  },
  {
    id: "amenities",
    displayName: t("propertypage.components.propertyheader.amenities"),
  },
  {
    id: "house_rules",
    displayName: t("propertypage.components.propertyheader.houserules"),
  },
  {
    id: "payment_and_fees",
    displayName: t("propertypage.paymentandfees.header"),
  },
  {
    id: "floor-layout",
    displayName: t("propertypage.components.actionbuttonsection.floorplan"),
  },
  {
    id: "meet_the_residents",
    displayName: t("propertypage.components.meettheresidents"),
  },
  {
    id: "faqs",
    displayName: t("propertypage.components.propertyheader.faqs"),
  },
  {
    id: "map",
    displayName: t("propertypage.components.propertyheader.map"),
  },
  {
    id: "reviews",
    displayName: t("propertypage.components.propertyheader.reviews"),
  },
  {
    id: "price_trend",
    displayName: t("propertypage.components.propertyheader.pricetrend"),
  },
  // {
  //   id: "similar_properties",
  //   displayName: t("propertypage.components.propertyheader.similarproperties"),
  // },
  // {
  //   id: "nearby_properties",
  //   displayName: t("propertypage.components.propertyheader.nearbyproperties"),
  // },
  // {
  //   id: "popular_properties",
  //   displayName: t("propertypage.components.propertyheader.popularproperties"),
  // },
  // {
  //   id: "budget_friendly_properties",
  //   displayName: t("propertypage.components.propertyheader.budgetfriendlyproperties"),
  // },
];

export const navigationData = (t: any) => [
  {
    id: "overview",
    displayName: t("propertypage.components.propertyheader.overview"),
  },
  {
    id: "offers",
    displayName: t("propertypage.components.propertyheader.offers"),
  },
  {
    id: "description",
    displayName: t("propertypage.components.propertyheader.description"),
  },
  {
    id: "video_tour",
    displayName: t("propertypage.components.propertyheader.videotour"),
  },
  {
    id: "room_type",
    displayName: t("propertypage.components.propertyheader.roomtypes"),
    triggerInViewEvent: true,
  },
  {
    id: "amenities",
    displayName: t("propertypage.components.propertyheader.amenities"),
  },
  {
    id: "house_rules",
    displayName: t("propertypage.components.propertyheader.houserules"),
  },
  {
    id: "payment_and_fees",
    displayName: t("propertypage.paymentandfees.header"),
  },
  {
    id: "floor-layout",
    displayName: t("propertypage.components.actionbuttonsection.floorplan"),
  },
  {
    id: "meet_the_residents",
    displayName: t("propertypage.components.meettheresidents"),
  },
  {
    id: "faqs",
    displayName: t("propertypage.components.propertyheader.faqs"),
  },
  {
    id: "map",
    displayName: t("propertypage.components.propertyheader.map"),
  },
  {
    id: "reviews",
    displayName: t("propertypage.components.propertyheader.reviews"),
  },
  {
    id: "price_trend",
    displayName: t("propertypage.components.propertyheader.pricetrend"),
  },
  // {
  //   id: "similar_properties",
  //   displayName: t("propertypage.components.propertyheader.similarproperties"),
  // },
  // {
  //   id: "nearby_properties",
  //   displayName: t("propertypage.components.propertyheader.nearbyproperties"),
  // },
  // {
  //   id: "popular_properties",
  //   displayName: t("propertypage.components.propertyheader.popularproperties"),
  // },
  // {
  //   id: "budget_friendly_properties",
  //   displayName: t("propertypage.components.propertyheader.budgetfriendlyproperties"),
  // },
];

export const navigationDataMapsV2 = (t: any) => [
  {
    id: "overview",
    displayName: t("propertypage.components.propertyheader.overview"),
  },
  {
    id: "offers",
    displayName: t("propertypage.components.propertyheader.offers"),
  },
  {
    id: "description",
    displayName: t("propertypage.components.propertyheader.description"),
  },
  {
    id: "video_tour",
    displayName: t("propertypage.components.propertyheader.videotour"),
  },
  {
    id: "room_type",
    displayName: t("propertypage.components.propertyheader.roomtypes"),
    triggerInViewEvent: true,
  },
  {
    id: "amenities",
    displayName: t("propertypage.components.propertyheader.amenities"),
  },
  {
    id: "house_rules",
    displayName: t("propertypage.components.propertyheader.houserules"),
  },
  {
    id: "payment_and_fees",
    displayName: t("propertypage.paymentandfees.header"),
  },
  {
    id: "floor-layout",
    displayName: t("propertypage.components.actionbuttonsection.floorplan"),
  },
  {
    id: "meet_the_residents",
    displayName: t("propertypage.components.meettheresidents"),
  },
  {
    id: "faqs",
    displayName: t("propertypage.components.propertyheader.faqs"),
  },
  {
    id: "map",
    displayName: t("propertypage.components.propertyheader.map"),
  },
  {
    id: "reviews",
    displayName: t("propertypage.components.propertyheader.reviews"),
  },
  {
    id: "price_trend",
    displayName: t("propertypage.components.propertyheader.pricetrend"),
  },
  // {
  //   id: "similar_properties",
  //   displayName: t("propertypage.components.propertyheader.similarproperties"),
  // },
  // {
  //   id: "nearby_properties",
  //   displayName: t("propertypage.components.propertyheader.nearbyproperties"),
  // },
  // {
  //   id: "popular_properties",
  //   displayName: t("propertypage.components.propertyheader.popularproperties"),
  // },
  // {
  //   id: "budget_friendly_properties",
  //   displayName: t("propertypage.components.propertyheader.budgetfriendlyproperties"),
  // },
];
